const loadData = <T>(key: string) : T | '' => {
  const data = localStorage.getItem(key);
  if (data) {
    return JSON.parse(data);
  }
  return '';
};

const saveData = (key: string, data: any) : void => {
  localStorage.setItem(key, JSON.stringify(data));
};

const clearData = () : void => {
  localStorage.clear();
};

export { loadData, saveData, clearData };
